import { useRef, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useTracker(token) {
  const timerRef = useRef({});

  const track = useCallback(async (eventType, data = {}) => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const endpoint = token ? `${API}/analytics/track` : `${API}/analytics/track-anon`;
      await axios.post(endpoint, { event_type: eventType, ...data }, { headers });
    } catch {}
  }, [token]);

  const startTimer = useCallback((propertyId) => {
    timerRef.current[propertyId] = Date.now();
  }, []);

  const stopTimer = useCallback((propertyId) => {
    const start = timerRef.current[propertyId];
    if (start) {
      const seconds = Math.round((Date.now() - start) / 1000);
      delete timerRef.current[propertyId];
      if (seconds > 1) {
        track('listing_view', { property_id: propertyId, duration_seconds: seconds });
      }
    }
  }, [track]);

  return { track, startTimer, stopTimer };
}
